"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloudDisplayName = exports.Cloud = void 0;
var Cloud;
(function (Cloud) {
    Cloud["AWS"] = "aws";
    Cloud["AZURE"] = "azure";
    Cloud["GCP"] = "gcp";
})(Cloud || (exports.Cloud = Cloud = {}));
//Display names for Signup Cloud Dropdown
exports.CloudDisplayName = {
    [Cloud.AWS]: 'Amazon Web Services',
    [Cloud.AZURE]: 'Microsoft Azure',
    [Cloud.GCP]: 'Google Cloud Platform',
};
//# sourceMappingURL=cloud.js.map